export * from './side-bar.directive';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/directives/side-bar/index.ts